module.exports = __webpack_public_path__ + "img/229401.1ea7a9cf.svg";